import { render, staticRenderFns } from "./JdInbond.vue?vue&type=template&id=ed7610a8&scoped=true&"
import script from "./JdInbond.vue?vue&type=script&lang=js&"
export * from "./JdInbond.vue?vue&type=script&lang=js&"
import style0 from "./JdInbond.vue?vue&type=style&index=0&id=ed7610a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7610a8",
  null
  
)

export default component.exports